import { Table, TableBody, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { MISSIONS_HEADER } from '@bo-constants/missions';
import { MissionRow } from '@library/components/table/rows/MissionRow';
import { NoResults } from '@library/components/NoResults';
import { useGetMissionsQuery } from '@bo-services/promotionsApi';

export const MissionsList = () => {
  const { data: missionsData, isLoading: isLoadingMissions } =
    useGetMissionsQuery({
      page: 1,
      perPage: 20
    });

  if (isLoadingMissions) {
    return <Loading loadingMessage="Loading Missions" />;
  }

  if (!missionsData?.challenges?.length) {
    return (
      <NoResults className="m-0" label="Use the search bar to search by Name" />
    );
  }

  return (
    <Table>
      <div className="flex flex-col overflow-x-auto" data-testid="Missions">
        <TableHeader headers={MISSIONS_HEADER} />
        <TableBody>
          {missionsData?.challenges.map((mission) => (
            <MissionRow key={mission.id} mission={mission} />
          ))}
        </TableBody>
      </div>
    </Table>
  );
};
